const config = Object.freeze({
  apiUrl: process.env.REACT_APP_API_URL,
  pluginId: process.env.REACT_APP_PLUGIN_ID,
  pluginUrl: 'https://chrome.google.com/webstore/detail/find-email/bhbcbkonalnjkflmdkdodieehnmmeknp',
  websiteUrl: 'https://getprospect.com',
  intercomAppId: 'ysppe2is',
  fingerprintToken: process.env.REACT_APP_FINGERPRINT_TOKEN,
  gmailClientId: process.env.REACT_APP_GMAIL_CLIENT_ID,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  tinyMceToken: process.env.REACT_APP_TINY_MCE_TOKEN,
  websiteAppUrl: process.env.REACT_APP_WEBSITE_APP_URL,
  storefrontApiTest: 'getprospect.test.onfastspring.com/popup-getprospect',
  storefrontApi: 'getprospect.onfastspring.com/popup-getprospect',
  storefrontApiB2BTest: 'getprospect.test.onfastspring.com/popup-defaultB2B',
  storefrontApiB2B: 'getprospect.onfastspring.com/popup-defaultB2B',
  cdnUrl: 'https://cdn.getprospect.com',
  googleSheetsClientId: process.env.REACT_APP_GOOGLE_SHEETS_CLIENT_ID,
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  pipedriveClientId: process.env.REACT_APP_PIPEDRIVE_CLIENT_ID,
  pipedriveRedirectUrl: `${process.env.REACT_APP_WEBSITE_APP_URL}/oauth/pipedrive/verify`,
  hubspotClientId: process.env.REACT_APP_HUBSPOT_CLIENT_ID,
  hubspotRedirectUrl: `${process.env.REACT_APP_WEBSITE_APP_URL}/oauth/hubspot/verify`,
  salesforceClientId: process.env.REACT_APP_SALESFORCE_CLIENT_ID,
  salesforceRedirectUrl: `${process.env.REACT_APP_WEBSITE_APP_URL}/oauth/salesforce/verify`,
  zohoClientId: process.env.REACT_APP_ZOHO_CLIENT_ID,
  zohoRedirectUrl: `${process.env.REACT_APP_WEBSITE_APP_URL}/oauth/zoho/verify`,
  sequencesOn: process.env.REACT_APP_SEQUENCES_ON,
  sequenceOpenTrackingOn: process.env.REACT_APP_SEQUENCE_OPEN_TRACKING_ON,
  disableGroups: true,
  turnstileSiteKey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
  pluginTest: true,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  demoMode: process.env.REACT_APP_DEMO_MODE,
  demoAccountToken: process.env.REACT_APP_DEMO_ACCOUNT_TOKEN,
  logoDevToken: process.env.REACT_APP_LOGO_DEV_TOKEN,
});

export default config;
